export const useCheckoutStore = defineStore('checkout', () => {
    const shippingData = ref({});
    const paymentData = ref({});
    const shippingTypes = ref([]);
    const errors = ref({});
    const parameters = ref({});
    const parametersPrices = ref({});

    const bundleLimit = ref(0);
    const bundleOptions = ref({});
    const bundledInvoices = ref([]);
    const bundling = ref(false);
    const bundleUnpaidInvoices = ref([]);

    const shippingPrice = ref(0);
    const totalPrice = ref(0);
    const checkoutKey = ref(Date.now().toString());

    const guest = ref(false);

    async function updateShippingField(field, value) {
        if (guest.value) {
            const url = 'checkout/shipping/guest/update-fields';
            const payload = [{ field, value }];

            const pricesLoadingAttributes = [
                'ship_to_country_id',
                'address',
                'city',
                'zip',
                'state_id',
                'postponed_shipment',
                'shipment_insurance.set',
                'sealed_bag.set',
            ];

            try {
                const response = await getFromClient(url, {
                    method: 'PATCH',
                    body: { updates: payload },
                    loading: field === 'shipping_type_id',
                    pricesLoading: pricesLoadingAttributes.includes(field),
                });

                if (response) {
                    refreshCheckoutKey();
                    setShippingData(response);
                }

                return response;
            } catch (error) {
                throw error;
            }
        } else {
            const url = 'checkout/shipping/update-fields';
            const payload = [{ field, value }];
            try {
                const response = await useClientFetch(url, {
                    method: 'PATCH',
                    body: { updates: payload },
                    loading: field === 'shipping_type_id',
                    pricesLoading: [
                        'address_book_id',
                        'shipping_destination',
                        'postponed_shipment',
                        'sealed_bag.set',
                        'shipment_insurance.set',
                    ].includes(field),
                });

                if (response) {
                    refreshCheckoutKey();
                    setShippingData(response.data);
                }

                return response;
            } catch (error) {
                throw error;
            }
        }
    }

    function setShippingData(data) {
        if (data.parameters) {
            parameters.value = data.parameters;
        }
        shippingData.value = data;
        setGlobalData(data);
    }

    function setPaymentData(data) {
        paymentData.value = data;
        setGlobalData(data);
    }

    function setGlobalData(data) {
        setPricesData(data);
        setBundleData(data);
    }

    function setPricesData(data) {
        totalPrice.value = data.total_price;
        shippingPrice.value = data.delivery_price;
        errors.value = data.errors;
        if (data.parameters_prices) {
            Object.keys(data.parameters_prices).forEach((key) => {
                parametersPrices.value[key] = data.parameters_prices[key];
            });
        }
        if (data.shipping_types) {
            shippingTypes.value = data.shipping_types;
        }
    }

    function setBundleData(data) {
        bundleLimit.value = data.bundle_limit;
        bundleOptions.value = data.bundle_options;
        bundledInvoices.value = data.bundled_invoices || [];
        bundling.value = bundledInvoices.value?.length > 1;
        bundleUnpaidInvoices.value = data.unpaid_invoices;
    }

    function refreshCheckoutKey() {
        checkoutKey.value = Date.now().toString();
    }

    return {
        shippingData,
        paymentData,
        errors,
        guest,
        updateShippingField,
        shippingPrice,
        totalPrice,
        setPaymentData,
        setShippingData,
        setGlobalData,
        setPricesData,
        shippingTypes,
        checkoutKey,
        refreshCheckoutKey,
        parameters,
        parametersPrices,

        setBundleData,
        bundleOptions,
        bundling,
        bundledInvoices,
        bundleUnpaidInvoices,
        bundleLimit
    }
});
